import React, { useState, useEffect, useLayoutEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import { slide as Menu } from 'react-burger-menu';
import '@/components/layout/Header.scss';
import logo from '@/assets/logo-cormorantgaramond.svg';

const sections = [
  { id: 'ventures/real-estate', label: 'Real Estate', page: true },
  { id: 'ventures/aviation', label: 'Aviation', page: true },
  { id: 'ventures/ephemera-foundation', label: 'Foundation', page: true },
  { id: 'principals', label: 'Principals', page: true },
  { id: 'legal', label: 'Legal', page: true },
  { id: 'terms', label: 'Terms', page: true },
  { id: 'privacy', label: 'Privacy', page: true },
];

const Header: React.FC = () => {
  const [activeSection, setActiveSection] = useState('hero');
  const [menuOpen, setMenuOpen] = useState(false);
  // const [openDropdown, setOpenDropdown] = useState<string | null>(null);
  const isMobile = useMediaQuery({ query: '(max-width: 1172px)' });
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setActiveSection(id);
      setMenuOpen(false);
    }
  };

  const handleNavigation = (id: string, page?: boolean) => {
    if (page) {
      const [path, hash] = id.split('#');
      const targetPath = path.startsWith('/') ? path : `/${path}`;
      const isSamePage = location.pathname === targetPath;

      if (isSamePage) {
        if (hash) {
          navigate(`${targetPath}#${hash}`);

          const element = document.getElementById(hash);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        } else {
          navigate(targetPath);

          window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
          });

          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
        }
      } else {
        navigate(`/${id}`, {
          state: { scrollToTop: !hash },
        });
      }
    } else if (location.pathname !== '/') {
      navigate('/', { state: { scrollToTop: !id.includes('#') } });
      setTimeout(() => {
        scrollToSection(id);
      }, 300);
    } else {
      scrollToSection(id);
    }

    setActiveSection(id);
    setMenuOpen(false);
  };

  // const toggleDropdown = (dropdownId: string) => {
  //   setOpenDropdown(prev => (prev === dropdownId ? null : dropdownId));
  // };

  // const handleMouseEnter = (id: string) => {
  //   setOpenDropdown(id);
  // };

  // const handleMouseLeave = () => {
  //   setOpenDropdown(null);
  // };

  const renderMenuItem = (id: string, label: string, page?: boolean) => (
    <div key={id} className="header__nav-item">
      <a
        className={activeSection === id ? 'active' : ''}
        onClick={() => handleNavigation(id, page)}
      >
        {label}
      </a>
    </div>
  );

  // const renderDropdown = (id: string) => {
  //   const isWhatWeDoSection = id === 'what-we-do';

  //   const handleDropdownInteraction = isMobile
  //     ? () => toggleDropdown(id)
  //     : (e: React.MouseEvent) => {
  //         if (e.type === 'mouseenter') handleMouseEnter(id);
  //         if (e.type === 'mouseleave') handleMouseLeave();
  //       };

  // return (
  //   <div
  //     key={id}
  //     className={`dropdown${isMobile ? '-mobile ' : ''} ${openDropdown === id ? 'active' : ''}`}
  //     onMouseEnter={!isMobile ? handleDropdownInteraction : undefined}
  //     onMouseLeave={!isMobile ? handleDropdownInteraction : undefined}
  //     onClick={isMobile ? handleDropdownInteraction : undefined}
  //   >
  //     <a className="dropdown-link">
  //       {sections.find(section => section.id === id)?.label}
  //       <ChevronDown className="dropdown-arrow" size={24} strokeWidth={2} />
  //     </a>
  {
    /* {openDropdown === id && (
          <div className={isMobile ? 'dropdown-menu-mobile' : 'dropdown-menu'}>
            <a onClick={() => navigate('/ventures/aviation')}>Aviation</a>
            <a onClick={() => navigate('/ventures/fine-art')}>Fine Art</a>
            <a onClick={() => navigate('/ventures/real-estate-hospitality')}>
              Real Estate & Hospitality
            </a>
          </div>
        )} */
  }
  //     </div>
  //   );
  // };

  useLayoutEffect(() => {
    const hasHash = location.hash || location.pathname.includes('#');

    if (!hasHash) {
      if ('scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'manual';
      }

      const performScroll = () => {
        window.scrollTo(0, 0);
        document.documentElement.scrollTo(0, 0);
        document.body.scrollTo(0, 0);
      };

      performScroll();
      requestAnimationFrame(performScroll);
    }
  }, [location.pathname]);
  useEffect(() => {
    const handleScroll = () => {
      let current = 'hero';
      sections.forEach(({ id }) => {
        const section = document.getElementById(id);
        if (section) {
          const top = section.getBoundingClientRect().top;
          if (top - 100 <= 0) current = id;
        }
      });
      setActiveSection(current);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className="header">
      <div className="header__inner">
        <div className="header__logo" onClick={() => handleNavigation('hero')}>
          <img src={logo} alt="Ephemera Partners" className="header__logo-img" />
        </div>

        {isMobile ? (
          <Menu
            right
            isOpen={menuOpen}
            noOverlay={false}
            onStateChange={state => setMenuOpen(state.isOpen)}
            customCrossIcon={false}
            burgerButtonClassName="bm-burger-button"
            burgerBarClassName="bm-burger-bars"
            menuClassName="bm-menu"
            itemListClassName="bm-item-list"
            overlayClassName="bm-overlay"
          >
            {sections.map(({ id, label, page }) => renderMenuItem(id, label, page))}
          </Menu>
        ) : (
          <nav className="header__nav">
            {sections.map(({ id, label, page }) => renderMenuItem(id, label, page))}
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
